import { Text } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";

const Stat = ({stat, text}) => {
  return <div className="border-l-3 border-solid border-[#DFFF5D] px-4">
    <Text variant="text-3xl/leading-normal/medium" className="text-[#FBFBFB] mb-3">
      {stat}
    </Text>

    <Text variant="text-base/leading-normal/normal" className="text-[#A3A3A3]">
      {text}
    </Text>
  </div>
}

const StatsBigSection = (props) => {
  return (
    <div className="bg-[#1A1A19]">
      <section className="w-full py-5 container">
        <div className={`flex flex-col-reverse ${!props.flip ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-4 lg:gap-16  py-3 lg:py-24`}>
          {/* Left Side: Text Content */}
          <div className="w-full flex flex-col justify-between">
            <Text variant="text-sm/leading-normal/normal" className="text-[#F5F5F5]">
              {props.sectionName}
            </Text>

            <Text variant="text-3xl/leading-normal/medium" className="text-[#FBFBFB] my-5">
              {props.title}
            </Text>
            <Text variant="text-base/leading-normal/normal" className="text-[#F5F5F5] whitespace-pre-line">
              {props.text}
            </Text>

            <div className="flex flex-col gap-8 mt-12">
              <Stat stat="100%" text="Full kontroll över din skog"/>

              <Stat stat="52 000+" text="Skogsägare använder Treebula"/>

              <Stat stat="4 000 000+" text="Hektar analyserad skogsdata"/>
            </div>
          </div>
          <div className="w-full flex justify-center items-center">
            <div className="w-full aspect-[3/4] bg-gray-100 rounded-xl relative overflow-hidden">
              <img
                alt={props.alt || "Hero image"}
                src={props.src || "https://placehold.co/600x800"}
                className={"w-full h-full object-cover vb-rounded"}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

StatsBigSection.defaultProps = {
  sectionName: "Hero section",
  title: "Headline that solves user's main problem",
  text: "Follow with one or two sentences that expand on your value proposition. Focus on key benefits and address why users should take action now. Keep it scannable, direct and benefit-driven.",
  mediaType: "image",
  src: "https://placehold.co/600x800",
  alt: "scenic image",
};

StatsBigSection.fields = {
  sectionName: {
    type: "text",
    label: "Section Name",
  },
  title: {
    type: "text",
    label: "Title",
  },
  text: {
    type: "textarea",
    label: "Description Text",
  },
  src: {
    type: "custom",
    label: "Image Source",
    render: ({ name, onChange, value }) => (
      <MediaSelector
        name={name}
        label="Image Source"
        type={"img"}
        onChange={onChange}
        value={value}
      />
    ),
  },
  alt: {
    type: "text",
    label: "Image Alt Text",
  }
};

export default StatsBigSection;
